import axios from "axios";

const axiosInstance = axios.create({
  timeout: 10000,
  baseURL: process.env.VUE_APP_BASE_ROOT,
});

export default axiosInstance;
